import React, { useMemo, useState } from 'react';
import { InfoCliente, InfoPago, Voucher, Card } from './OrdenWebDetallePendiente';

/* ===== helpers mínimos (mismos que en Pendiente) ===== */
const resolveApiBase = (apiBaseProp) => {
  const fromProp = (apiBaseProp || '').trim();
  if (fromProp) return fromProp.replace(/\/+$/, '');
  const isLocal = ['localhost','127.0.0.1'].includes(window.location.hostname);
  return (isLocal ? 'http://localhost:5001' : window.location.origin).replace(/\/+$/, '');
};

const fetchJSON = async (url, opts = {}) => {
  const resp = await fetch(url, { credentials: 'include', ...opts });
  let j = null; try { j = await resp.json(); } catch {}
  if (!resp.ok || (j && j.ok === false)) {
    const msg = (j && j.msg) || resp.statusText || `HTTP ${resp.status}`;
    const err = new Error(msg);
    err.status = resp.status;
    err.payload = j;
    throw err;
  }
  return j ?? {};
};
/* ================================================ */

// Versión sin imagen para productos (reutiliza Card exportado)
function ProductosSinImagen({ p }) {
  const items = Array.isArray(p.pedido) ? p.pedido : (p.pedido && p.pedido.items ? p.pedido.items : []);
  if (!items.length) return <Card title="Productos"><div className="text-sm text-gray-500">Sin items.</div></Card>;
  return (
    <Card title="Productos">
      <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-3">
        {items.map((it, idx) => (
          <div key={idx} className="border rounded-lg p-3">
            <div className="text-sm font-semibold">{it.nombre}</div>
            <div className="mt-2 text-sm text-gray-600">
              Cantidad: {it.cantidad !== undefined ? it.cantidad : (it.qty !== undefined ? it.qty : 1)}
            </div>
            {(it.precio !== undefined || it.price !== undefined) && (
              <div className="text-sm">Precio: Q{Number(it.precio !== undefined ? it.precio : it.price).toFixed(2)}</div>
            )}
          </div>
        ))}
      </div>
    </Card>
  );
}

export default function OrdenWebDetalleEnRuta({ API_BASE, fileUrl, pedido, onClose, onEstadoCambiado }) {
  const base = useMemo(() => resolveApiBase(API_BASE), [API_BASE]);
  const [busy, setBusy] = useState(false);

  const enviarARutas = async () => {
    if (busy) return;
    setBusy(true);
    try {
      const url = `${base}/api/web/pedidos/id/${pedido.id}/enviar-a-ruta`;
      console.log('[POST enviar-a-ruta] ->', url);
      await fetchJSON(url, { method: 'POST' });
      alert('Enviado a rutas');
    } catch (e) {
      console.error('[enviarARutas] error:', e);
      alert(e.message || 'No se pudo enviar a rutas');
    } finally {
      setBusy(false);
    }
  };

  const notificarCliente = () => {
    if (!pedido.whatsapp) return alert('Este pedido no tiene número de WhatsApp.');
    const msg = `Su pedido se encuentra en el lugar. Por favor confirmar de recibido.`;
    const phone = String(pedido.whatsapp).replace(/[^\d]/g, '');
    window.open(`https://wa.me/${phone}?text=${encodeURIComponent(msg)}`, '_blank');
  };

  const marcarEntregado = async () => {
    if (busy) return;
    setBusy(true);
    try {
      const url = `${base}/api/web/pedidos/id/${pedido.id}/estado`;
      console.log('[PATCH estado] ->', url, { estado: 'Entregado' });
      await fetchJSON(url, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ estado: 'Entregado' }),
      });
      onEstadoCambiado(pedido.id, 'Entregado');
    } catch (e) {
      console.error('[marcarEntregado] error:', e);
      alert(e.message || 'No se pudo actualizar');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col">
        <div className="flex justify-between items-center p-4 border-b sticky top-0 bg-white rounded-t-2xl z-10">
          <h2 className="text-xl font-bold">Pedido #{pedido.id} (En Ruta)</h2>
          <button onClick={onClose} className="px-3 py-1.5 text-sm rounded-lg border border-gray-200">Cerrar</button>
        </div>

        <div className="p-6 space-y-4 overflow-y-auto">
          <InfoCliente p={pedido} />
          <InfoPago p={pedido} />
          <ProductosSinImagen p={pedido} />
          <Voucher p={pedido} API_BASE={base} fileUrl={fileUrl} />

          <div className="flex flex-wrap justify-end gap-2 pt-2">
            <button onClick={onClose} className="px-4 py-2 rounded-xl border border-gray-200">
              Cancelar
            </button>
            <button
              onClick={enviarARutas}
              className="px-4 py-2 rounded-xl border border-sky-200 text-sky-700 hover:bg-sky-50 disabled:opacity-60"
              disabled={busy}
            >
              {busy ? 'Enviando...' : 'Enviar a rutas'}
            </button>
            <button
              onClick={notificarCliente}
              className="px-4 py-2 rounded-xl border border-emerald-200 text-emerald-700 hover:bg-emerald-50"
            >
              Notificar al cliente
            </button>
            <button
              onClick={marcarEntregado}
              className="px-4 py-2 rounded-xl bg-emerald-600 text-white hover:bg-emerald-700 disabled:opacity-60"
              disabled={busy}
            >
              {busy ? 'Guardando...' : 'Marcar como Entregado'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
